/*
 * Copyright (C) 2019 Toshiba Corporation
 * SPDX-License-Identifier: Apache-2.0
 */

import { DThemeChartLegendItem } from "../../d-chart-legend-item";
import { DThemeDarkBase } from "./d-theme-dark-base";

export class DThemeDarkChartLegendItem extends DThemeDarkBase implements DThemeChartLegendItem {}
